import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48e4a1e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Home")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 待付款 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 待接单 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 待发货 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 已发货 ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "headline" }, " 我是标题 ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scoolr" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_search = _resolveComponent("search")!
  const _component_banner = _resolveComponent("banner")!
  const _component_advert = _resolveComponent("advert")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_HelloWorld = _resolveComponent("HelloWorld")!
  const _component_header_menu = _resolveComponent("header-menu")!
  const _component_iconDesign = _resolveComponent("iconDesign")!
  const _component_count_down = _resolveComponent("count-down")!
  const _component_headline = _resolveComponent("headline")!
  const _component_WishList = _resolveComponent("WishList")!
  const _component_scrolltop = _resolveComponent("scrolltop")!
  const _component_filtrate = _resolveComponent("filtrate")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: "/home" }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_search),
      _createVNode(_component_banner),
      _createVNode(_component_advert, { url: "https://image.kilimall.com/kenya/shop/adv/41738715869d218d7774afa48d7a80fc.jpg.webp" }),
      _createVNode(_component_van_row, { class: "user-links" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_icon, { name: "pending-payment" }),
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_icon, { name: "records" }),
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_icon, { name: "tosend" }),
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_icon, { name: "logistics" }),
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_HelloWorld, { msg: "Welcome to Your Vue.js + TypeScript App" }),
      _createElementVNode("div", null, [
        _createVNode(_component_header_menu, {
          moreMenu: $setup.moreMenu,
          backgroundColor: "#000",
          fontColor: "#fff",
          ref: "headerMenu",
          skipPath: "https://www.baidu.com"
        }, {
          center: _withCtx(() => [
            _hoisted_7
          ]),
          right: _withCtx(() => [
            _createVNode(_component_van_icon, {
              name: "share-o",
              size: "22px",
              onClick: $setup.shareEvent
            }, null, 8, ["onClick"]),
            _createVNode(_component_van_icon, {
              name: "ellipsis",
              size: "22px",
              onClick: $setup.openMenu
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["moreMenu"])
      ])
    ]),
    _createVNode(_component_iconDesign, {
      master: 4,
      iconList: $setup.iconList
    }, null, 8, ["iconList"]),
    _createVNode(_component_iconDesign, {
      master: 5,
      iconList: $setup.iconList
    }, null, 8, ["iconList"]),
    _createVNode(_component_count_down, {
      backgroundColor: "#000",
      timestamp: "1607043833",
      start_timestamp: "1607058000"
    }),
    _createVNode(_component_headline, {
      title: "我是传递的标题",
      more: true,
      size: "18",
      colors: "#000",
      skipPath: "/跳转路径"
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productList, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.goods_id
      }, [
        _createVNode(_component_WishList, {
          good_objs: item,
          onBeforeClose: $setup.beforeClose
        }, null, 8, ["good_objs", "onBeforeClose"])
      ]))
    }), 128)),
    _hoisted_8,
    _createVNode(_component_scrolltop),
    _createVNode(_component_van_popup, {
      show: $setup.showFiltrate,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($setup.showFiltrate) = $event)),
      position: "right",
      "close-icon": "",
      style: { height: '100%',width:'85%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_filtrate, {
          onPopupClick: $setup.popupClick,
          category: $setup.categorys.data,
          brands: _ctx.brands,
          onCategoryList: $setup.categoryList,
          onFixationVlaue: $setup.fixationVlaue
        }, null, 8, ["onPopupClick", "category", "brands", "onCategoryList", "onFixationVlaue"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}